import { render, staticRenderFns } from "./ModulosCurso.vue?vue&type=template&id=87a571f2&scoped=true&"
import script from "./ModulosCurso.vue?vue&type=script&lang=js&"
export * from "./ModulosCurso.vue?vue&type=script&lang=js&"
import style0 from "./ModulosCurso.vue?vue&type=style&index=0&id=87a571f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a571f2",
  null
  
)

export default component.exports